class Manifesto extends HTMLElement {
  constructor() {
    super();
    const self = this;
    this.sectionId = this.getAttribute('data-section');
    this.addEventTab();
    this.initSlider();

    this.querySelectorAll('.manifesto-media-item').forEach((item) => {
      item.addEventListener('mouseover', function () {
        if (window.innerWidth >= 990) {
          const blockMerge = `block-manifesto-${item.getAttribute('data-block-connect')}`;
          self.querySelector(`div[data-open="${blockMerge}"]`)?.click();
          self.querySelector('.manifesto-media-item.active')?.classList.remove('active');
          this.classList.add('active');
        }
      });
    });

    this.bindMobileSlideSync();
    window.addEventListener('resize', () => this.bindMobileSlideSync());
  }

  bindMobileSlideSync() {
    if (window.innerWidth >= 990) {
      if (this.swiperInstance) {
        this.swiperInstance.off('slideChange', this._onSlideChange);
      }
      return;
    }

    if (!this.swiperInstance) return;

    if (!this._onSlideChange) {
      this._onSlideChange = () => {
        const itemActive = this.querySelector('.swiper-slide-active');
        if (!itemActive) return;
        const blockMerge = `block-manifesto-${itemActive.getAttribute('data-block-connect')}`;
        this.querySelector(`div[data-open="${blockMerge}"]`)?.click();
      };
    }

    this.swiperInstance.on('slideChange', this._onSlideChange);
  }

  addEventTab() {
    const self = this;
    this.querySelectorAll('.title-manifesto').forEach((item) => {
      item.addEventListener('click', function () {
        if (!item.classList.contains('active')) {
          if (self.querySelector('.title-manifesto.active')) {
            let idBlock = self.querySelector('.title-manifesto.active').getAttribute('data-open');
            self.querySelector(`.description[data-block-open="${idBlock}"]`)?.classList.remove('active');
            self.querySelector('.title-manifesto.active').classList.remove('active');

            item.classList.add('active');
            idBlock = item.getAttribute('data-open');
            self.querySelector(`.description[data-block-open="${idBlock}"]`)?.classList.add('active');
          }
        }
      });
    });
  }

  initSlider() {
    const sectionId = this.sectionId;
    this.swiperInstance = new Swiper(`.manifesto-swiper-${sectionId}`, {
      slidesPerView: 1.536,
      spaceBetween: 8,
      loop: true,
      breakpoints: {
        990: {
          slidesPerView: 6,
        },
      },
    });
    this.bindMobileSlideSync();
  }
}
customElements.define('manifesto-section', Manifesto);
